import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import MTD from "@ss/mtd-vue";
import arLocale from "element-ui/lib/locale/lang/ar";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import "@bfe/mtd-theme-582/index.css";
// 接入芥末基座的 sdk -- 必须要有
import jiemoAppport from "@osgfe/jiemo-appport";
import "@osgfe/jiemo-appport/dist/style.css";

import { i18nPlugin, getCacheLocale } from "@sailor/i18n-vue";
import ChainedBackend from "i18next-chained-backend";
import OpenAPIBackend from "@sailor/i18n-web-openapi-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import resources from "./assets/locales/resources";

// TODO: 从远端拉取全屏页面，如果命中，则端上重定向到内壳页面
const fullScreenPages = [];

if (fullScreenPages.includes(window.location.pathname)) {
  const matchRel = window.location.pathname.match(/\/([\w]+)([\s\S]+)/);
  if (matchRel) {
    const redirectUrl = `/${matchRel[1]}-alias${matchRel[2]}${window.location.search}`;
    window.location.href = `${window.location.origin}${redirectUrl}`;
  }
}
const localeMap = {
  zh: zhLocale,
  en: enLocale,
  ar: arLocale,
};

export default function (App) {
  const currentLocaleStr = getCacheLocale() || "en";

  Vue.use(ElementUI, { locale: localeMap[currentLocaleStr] });
  Vue.use(jiemoAppport, { locale: localeMap[currentLocaleStr] });
  Vue.use(MTD);
  Vue.use(i18nPlugin, (i18nClient) => {
    i18nClient.use(ChainedBackend).init({
      fallbackLng: "en",
      // 配置backend
      backend: {
        backends: [OpenAPIBackend, resourcesToBackend(resources)],
        // 这里配置一下所使用的projectId和namespaceId
        backendOptions: [
          {
            env: process.env.NODE_ENV === "production" ? "prod" : "test",
            namespaces: [
              {
                projectId: 43,
                apiKey: "5960afab14104e319ab1a7db5057e908",
                namespaceId: "xiseqyo75q",
              },
            ],
          },
        ],
      },
    });
  });

  // eslint-disable-next-line no-new
  new Vue({
    el: "#app",
    render(h) {
      return h(App);
    },
  });

  window.Vue = Vue;
}
